import React, { FC } from 'react';
import useLocales from 'hooks/useLocales';
import { IPrivacyPolicyTerms } from 'hooks/type';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer/Index';
import PrivacyPolicyTermsCard from 'components/PrivacyPolicyCard';
import { privacyPolicy } from 'constants/constants';
import PageHeader from 'components/PageHeader';
import LanguageToggle from 'components/LanguageToggle';

import './index.scss';
import { IMe } from 'core/interface/me';
import { useSelector } from 'react-redux';

const PrivacyPolicy: FC = (): JSX.Element => {
  const { t } = useLocales();
  const me = useSelector((state: IMe) => state.user).user;

  const isAuthenticated = me !== null;

  return (
    <div
      className="privacyPolicy"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      {isAuthenticated ? (
        <Navbar />
      ) : (
        <>
          <PageHeader showLanguageSelector={false} />
          <LanguageToggle />
        </>
      )}
      <div className="privacyPolicy_content" style={{ flex: 1 }}>
        <h1 className="privacyPolicy_title">
          {t('Privacy Statement')}
        </h1>
        <div className="privacyPolicy_texts">
          {privacyPolicy.map((e: IPrivacyPolicyTerms, i: number) => (
            <PrivacyPolicyTermsCard
              title={t(e.title)}
              key={i}
              content={t(e.content)}
              className="terms_context_about"
            />
          ))}
          <div className="privacyPolicy_content_privacybeleid">
            {t('Skillio Privacybeleid, © 2025 Skillio.com. All rights reserved.')}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
